export default {
  defaultProps: {
    focusBorderColor: 'primary.500',
  },
}
